export function canRestartFromDraft({ isStreaming, draft, submittedText }) {
  if (!isStreaming) return false;
  const nextDraft = String(draft || '').trim();
  const activeText = String(submittedText || '').trim();
  return Boolean(nextDraft) && nextDraft !== activeText;
}

export function finalizeAssistantContent(fullText, existingContent = '') {
  const next = String(fullText || '').trim();
  if (next) return fullText;
  const existing = String(existingContent || '').trim();
  return existing ? existingContent : 'Service temporarily unavailable.';
}

export function removeActiveTurnMessages(messages, activeTurn) {
  if (!Array.isArray(messages) || !activeTurn) return Array.isArray(messages) ? messages : [];
  return messages.filter(
    (message) => message.localId !== activeTurn.userLocalId && message.localId !== activeTurn.assistantLocalId,
  );
}

export function updateMessageByLocalId(messages, localId, updater) {
  if (!Array.isArray(messages) || !localId || typeof updater !== 'function') return Array.isArray(messages) ? messages : [];
  let didChange = false;
  const next = messages.map((message) => {
    if (message.localId !== localId) return message;
    didChange = true;
    return updater(message);
  });
  return didChange ? next : messages;
}
